<template>
	<div>
		<v-toolbar flat fixed>
            <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
            <v-toolbar-title class="white--text">Clear Data</v-toolbar-title>
        </v-toolbar>

        <div class="hasToolbar">
        	<v-list nopadding>

                <v-list-tile v-ripple @click="fn_openDialogConfirmation('transaction')">
                    <v-list-tile-content>
                        <v-list-tile-title>Clear Transactions</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>

                <v-divider></v-divider>

                <v-list-tile v-ripple @click="fn_openDialogConfirmation('all')">
                    <v-list-tile-content>
                        <v-list-tile-title>Clear All</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>

            </v-list>
        </div>

        <dialog-confirmation ref="ref_dialogConfirmation" :header="confirmationHeader" :confirmationMessage="confirmationMessage" :actionMethod="actionMethod" cancelBtnText="No" okBtnText="Yes" icon="error_outline" iconClass="redcolor"></dialog-confirmation>
	</div>
</template>


<script>
const dialogjs =  require('../../masters/forms/dialog').dialogjs;
import dialogConfirmation from '../../dialogs/dialog_confirmation'

	export default{
		data(){
			return{
				confirmationHeader:null,
				confirmationMessage:null,
				actionMethod:null,
				clearType:null
			}
		},
		components:{
	        'dialog-confirmation': dialogConfirmation
	    },
	    methods:{

	    	fn_openDialogConfirmation: function(type){
	            
	    		let fnName = null;
	    		this.actionMethod = this.fn_backupAllBusinessData;
	    		this.clearType = type;

	    		if(this.clearType=='all'){
	    			this.confirmationHeader = "Clear All Data?";
	    			this.confirmationMessage = "Are you sure you want to clear all data?";
	    			// this.actionMethod = this.fn_clearAllData;
	    		}
	    		else if(this.clearType=='transaction'){
	    			this.confirmationHeader = "Clear Transactions?";
	    			this.confirmationMessage = "Are you sure you want to clear all transactions?";
	    			// this.actionMethod = this.fn_clearTransactions;
	    		}
	    		
	            this.$refs['ref_dialogConfirmation'].dialog_confimation = true;
	        },

	        fn_closeDialog: function(){
	        	this.$refs['ref_dialogConfirmation'].dialog_confimation = false;
	        },

	        fn_clearAllData: function(){
	        	let self = this;
	        	// this.showLoading("Clearing all data...");
	            this.getData("ClearMasterAndTransactionData", null, 
	                {
	                    onSuccess: function(response){
	                        console.log(response);
	                        self.showToast("Deleted all masters and transactions");
	                        localStorage.clear();
	                        self.hideLoading();
	                        self.fn_backupAllBusinessData('general');
	                        // self.hideLoading();
	                    }, 
	                    onError: function(error){
	                        console.log(error);
	                        self.hideLoading();
	                        self.showToast('Something went wrong. Try again');
	                    }
	                }
	            );
	        },

	        fn_clearTransactions: function(){
	        	let self = this;
	        	// this.showLoading("Clearing transactions...");
	            this.getData("ClearTransactionData", null, 
	                {
	                    onSuccess: function(response){
	                        console.log(response);
	                        self.showToast("Deleted all transactions");
	                        localStorage.clear();
	                        self.hideLoading();
	                        self.fn_backupAllBusinessData('general');
	                        // self.hideLoading();
	                    }, 
	                    onError: function(error){
	                        console.log(error);
	                        self.hideLoading();
	                        self.showToast('Something went wrong. Try again');
	                    }
	                }
	            );
	        },

	        fn_backupAllBusinessData: function(complexType){

	            let self = this;
	            let filterObject = {}
	            // filterObject.complexOperation = complexType == 'general' ? false : true;
	            if(complexType == 'general'){
	            	this.showLoading("Backing up your data...");
					filterObject.complexOperation = false;
					filterObject.clearData  = true;
	            }
	            else{
	            	filterObject.complexOperation = true;
	            	this.showLoading("Please wait...");	
	            }

	            this.fn_closeDialog();

	            this.getFilterData('BackupAllData', this.$root.CurrentBusiness.BusinessID, filterObject,
	                {
	                    onSuccess: function(response){
	                        console.log(response);
	                        self.fn_reopenDB(complexType);
	                        // if(complexType!='general'){
	                        // 	self.clearType == 'all' ? self.fn_clearAllData() : self.fn_clearTransactions();
	                        // }
	                        // else{
	                        // 	self.hideLoading();
	                        // }
	                    },
	                    onError: function(error){
	                        console.log(error);
	                        self.fn_reopenDB(null, true);
	                        self.hideLoading();
	                        self.showToast('Something went wrong. Try again');
	                    }
	                }
	            );
	            
	        },

	        fn_reopenDB: function(complexType, isError){
                let self = this;
                this.getData('ReopenDataBase', this.$root.CurrentBusiness.BusinessID, 
                    {
                        onSuccess: function(response){
                            console.log(response);
                            if(isError){
                            	self.hideLoading();
                            }
                            else{
                            	if(complexType!='general'){
		                        	self.clearType == 'all' ? self.fn_clearAllData() : self.fn_clearTransactions();
		                        }
		                        else{
		                        	self.hideLoading();
		                        }
                            }
                            
                        }, 
                        onError: function(error){
                            console.log(error);
                        }
                    }
                );
            },

	        fn_goBack: function(){
	        	this.$router.go(-1);
	        }
	    },
	    mounted: function(){
	    	window.js_globals.fn_onBackPress = this.fn_goBack;
	    },
	    beforeRouteLeave(to, from, next){
	      if(this.$refs['ref_dialogConfirmation'].dialog_confimation){
	        this.$refs['ref_dialogConfirmation'].dialog_confimation = false;
	        next(false);
	      }
	      else{
	      	next();	
	      }
	    },
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/backup_data/clear_data.vue